import { H2, H3, H5 } from "#/components/Common/headings";
import { useAppDispatch, useAppSelector } from "#/store";
import { Button, Card, Grid, IconButton, Input } from "@mui/material";
import React from "react";
import {
    deleteSession,
    loadSession,
    saveSession,
    Session,
    toggleInterpretationFav,
} from "#store/ui";
import {
    AddCircle,
    Remove,
    RemoveCircleOutline,
    Save,
} from "@mui/icons-material";
import { generatePath } from "react-router";
import { Routes } from "#/config";
import { Link } from "#/components/Common/Link";

export const SessionsComponent = () => {
    const dispatch = useAppDispatch();

    const [sessionName, setSessionName] = React.useState<string>("");

    const activeInterpretations = useAppSelector(
        state => state.uiState.activeInterpretations
    );
    const savedSessions = useAppSelector(state => state.uiState.savedSessions);
    return (
        <>
            <H2>Bookmarks / Sessions</H2>
            <Grid container spacing={2}>
                <Grid item key={"create"} xs={4}>
                    <H3>Active interpretation</H3>
                    <ul>
                        {activeInterpretations.map((id, index) => {
                            return (
                                <li key={id}>
                                    {id}
                                    <IconButton
                                        onClick={() =>
                                            dispatch(
                                                toggleInterpretationFav(id)
                                            )
                                        }
                                        size={"small"}
                                    >
                                        <RemoveCircleOutline
                                            fontSize={"small"}
                                        />
                                    </IconButton>
                                </li>
                            );
                        })}
                    </ul>
                    <Input
                        placeholder={"Name this session to save"}
                        onChange={value => setSessionName(value.target.value)}
                    />
                    <IconButton
                        onClick={() =>
                            dispatch(
                                saveSession({
                                    label: sessionName,
                                    interpretations: activeInterpretations,
                                } as Session)
                            )
                        }
                        disabled={sessionName === ""}
                    >
                        <Save />
                    </IconButton>
                    <Button
                        onClick={() =>
                            activeInterpretations.forEach(id =>
                                dispatch(toggleInterpretationFav(id))
                            )
                        }
                    >
                        Remove all bookmarks
                    </Button>
                </Grid>
                {savedSessions.map(s => {
                    return (
                        <Grid item key={s.label} xs={2}>
                            <Card>
                                <H3>{s.label}</H3>
                                <ul>
                                    {s.interpretations.map(x => (
                                        <li key={x}>
                                            <Link
                                                to={generatePath(
                                                    Routes.interpretation.path,
                                                    { id: String(x) }
                                                )}
                                            >
                                                {x}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                                <Button
                                    onClick={() =>
                                        dispatch(loadSession(s.label))
                                    }
                                >
                                    Load
                                </Button>
                                <Button
                                    onClick={() =>
                                        dispatch(deleteSession(s.label))
                                    }
                                >
                                    Delete
                                </Button>
                            </Card>
                        </Grid>
                    );
                })}
            </Grid>
        </>
    );
};
